<template>
  <el-alert type="info"
            :closable="false">
    <div class="crud-amount">
      <el-tooltip placement="top"
                  effect="light">
        <div slot="content">
          <div v-html="responseData.amountStr||''"></div>
        </div>
        <div v-html="responseData.amountStr||''"
             ref="amount"
             v-ellipsis="2"></div>
      </el-tooltip>

    </div>
  </el-alert>
</template>

<script>
import OverTooltip from '@/basic-common/components/OverTooltip'

export default {
  name: 'AmountUnit',
  components: {
    OverTooltip,
  },
  props: {
    responseData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  created() {
  },

  methods: {
    disabled() {
      this.$nextTick(() => {
        console.log(this.$refs.amount)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
